import React from "react";
import FormContentLayout from "components/layout/FormContentLayout";
import Loading from "components/ui/Loading";

const PendingBankDataMessage = () => (
  <FormContentLayout
    heading="Thanks for connecting your checking account!"
    subheading="Please wait while we verify your income."
    useTile
  >
    <Loading />
  </FormContentLayout>
);

export default PendingBankDataMessage;
